export const environment = {
    production: true,
    API_URL: 'https://api-dev.fixdd.com/api/',
    INTERCOM_IOS_API_KEY: 'ios_sdk-c4a9287cdc8dc9ac653b54112745f73da84f5052',
    INTERCOM_IOS_APP_ID: 'nj1ivuj0',
    INTERCOM_ANDROID_API_KEY: 'android_sdk-8fb81a3202db90d9ea8c23d4c6467a3cb41e5d77',
    INTERCOM_ANDROID_APP_ID: 'nj1ivuj0',
    REVENUECAT_IOS_API_KEY: 'appl_peXmYjZHkCscNanCZOrlhVoULWx',
    REVENUECAT_ANDROID_API_KEY: 'goog_myvQdaBThHwDfcoEMWDdlEqEfve',
    //REVENUECAT_WEB_API_KEY: 'rcb_sb_trOXsbUCGgXcHuKALmsfNnyMg'
    REVENUECAT_WEB_API_KEY: 'strp_dOeRVdeNNgCxeXqxVAiJakrzYkz',
    CONFIGCAT: 'configcat-sdk-1/kNncCP2oAU-JnBfwhYsB3Q/wBOhmJXELkaMnj_snfOZqg',
    SENTRY_DSN: 'https://9bf854715634a6ff07a30540f04e095f@o72843.ingest.us.sentry.io/4506853034098688'
};
  